"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCommunityDescription = selectCommunityDescription;

// import type { Community } from '../types';
function selectCommunityDescription(communityId, communities) {
  if (!communities) {
    return '';
  }

  var targetCommunity = Object.values(communities).find( // $FlowFixMe
  function (community) {
    return parseInt(community.id) === communityId;
  });

  if (targetCommunity) {
    // $FlowFixMe
    return targetCommunity.label;
  } else {
    return '';
  }
}